export default {"src":"/_next/static/media/alert_new_error.8559de71.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};